export const scheduleTypeIds = {
  byWeekDays: 1,
  byEvenOddWeekDays: 2,
  byEvenOddMonthDays: 3,
};

export const evenOddDayIds = new Set([
  scheduleTypeIds.byEvenOddWeekDays,
  scheduleTypeIds.byEvenOddMonthDays,
]);

export const defaultScheduleTypeId = scheduleTypeIds.byWeekDays;
